import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  BankAddressStepRequest,
  BankAddressStepResponse,
  SavedBankAddressesResponse,
} from '../model';

const getSavedBankAddresses = async (options?: RequestHandlerOptions) => {
  const request = () => apiClient.get(`/operations/bank/template`);
  const response = await handleRequest<SavedBankAddressesResponse>(
    request,
    options
  );
  return response.data;
};

const getBankAddressStep = async (
  templateId?: string
): Promise<BankAddressStepResponse> => {
  const response = await apiClient.get<BankAddressStepResponse>(
    `/operations/bank/withdraw/params`,
    { params: { templateId } }
  );
  return response.data;
};

const submitBankAddressStep = async (
  requestBody: BankAddressStepRequest
): Promise<BankAddressStepResponse> => {
  const response = await apiClient.post<BankAddressStepResponse>(
    `/operations/bank/withdraw/params`,
    requestBody
  );
  return response.data;
};

export { getSavedBankAddresses, getBankAddressStep, submitBankAddressStep };
